import React from 'react';

const ExecutiveSummary: React.FC<{ text: string }> = ({ text }) => (
  <div className="py-4 border-b border-slate-200">
    <h3 className="text-[13px] font-semibold text-slate-900 mb-2">エグゼクティブサマリー</h3>
    <p className="text-[13px] text-slate-700 leading-relaxed whitespace-pre-line">{text}</p>
  </div>
);

export default ExecutiveSummary;
